import { Injectable, Inject, Optional, Injector } from "@angular/core";
import { ExpressRequest } from "./express-ssr";
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Router } from "@angular/router";

interface LoggerRequestDetails {
    requestId : string;
}

@Injectable()
export class LoggerService {
    constructor(
        @Optional() @Inject(REQUEST)
        private request : ExpressRequest,
        @Optional() @Inject('REQUEST_DETAILS')
        private requestDetails : LoggerRequestDetails,
        private injector : Injector
    ) {
    }

    get router() {
        return this.injector.get(Router);
    }

    public log(message : string) {
        let logPrefix : string = `${new Date().toISOString()}`;

        if (this.requestDetails)
            logPrefix += ` ${this.requestDetails.requestId}`;
            
        if (this.request)
            logPrefix += ` ${this.request.ip} ${this.request.method} ${this.request.url}`;
        else if (this.router)
            logPrefix += ` (client) VIEW ${this.router.routerState.snapshot.url}`

        console.log(`${logPrefix} | ${message}`);
    }

    public error(message : string) {
        this.log(`[ERROR] ${message}`);
    }

    public warning(message : string) {
        this.log(`[WARNING] ${message}`);
    }

    public info(message : string) {
        this.log(`[INFO] ${message}`);
    }

    public debug(message : string) {
        this.log(`[DEBUG] ${message}`);
    }
}